module.exports = __webpack_public_path__ + "img/doc_dashboard.40d2cf47.gif";